// Use a window-level singleton so that all Rollup bundles (config, toolbar,
// side-panel, canvas) share the same translations object.  Without this each
// bundle gets its own copy of this module with a separate local variable.
const GLOBAL_KEY = '__labellife_translations__';
if (typeof window !== 'undefined' && !window[GLOBAL_KEY]) {
  window[GLOBAL_KEY] = {};
}

function _get() {
  return (typeof window !== 'undefined' && window[GLOBAL_KEY]) || {};
}

function deepMerge(target, source) {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (
      source[key] &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key]) &&
      target[key] &&
      typeof target[key] === 'object' &&
      !Array.isArray(target[key])
    ) {
      result[key] = deepMerge(target[key], source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

export function setTranslations(newTranslations) {
  if (typeof window !== 'undefined') {
    window[GLOBAL_KEY] = deepMerge(_get(), newTranslations);
  }
}

export function getTranslations() {
  return _get();
}

export function t(key, defaultValue) {
  // Support dot-notation paths like 'toolbar.duration'
  const parts = key.split('.');
  let current = _get();
  for (const part of parts) {
    if (current == null || typeof current !== 'object') {
      return defaultValue || key;
    }
    current = current[part];
  }
  if (current !== undefined && current !== null && typeof current !== 'object') {
    return current;
  }
  return defaultValue || key;
}
